export const pageIds = {
  status: 695944,
  events: 318434,
  staffing: 5962,
  meetings: 9772,
  assets: 110,
  substances: 12368,
  dataSystems: 20,
  issues: 882901,
  riskAssessments: 712363,
  management: 357,
  hse: 63,
  business: 365,
  assetManagement: 355,
  informationSecurity: 65,
  quality: 79,
  company: 104,
  employees: 996526,
  partners: 312616,
  people: 476666,
  tutorials: 369026,
  references: 2250,
  trash: 223117,
  collections: 449726,
  screens: 660736,
  emergency: 302275,
};
